// extracted by mini-css-extract-plugin
module.exports = {"lia-list":"AttachmentList_lia-list__u2mmL","lia-pager":"AttachmentList_lia-pager__7pvat"};